import React, { useState } from "react";
import { IoGrid, IoDocumentTextOutline, IoAlertCircleOutline } from "react-icons/io5";
import { FaTableList, FaCalendarDays } from "react-icons/fa6";
import { FaCheckCircle } from "react-icons/fa";
import { formatText } from "../TruncateParties"; 

export const RenderObjectionDetails = ({ objectionDetails }) => {
  const [viewMode, setViewMode] = useState("table");

  const sortedObjections = objectionDetails
    ? [...objectionDetails].sort((a, b) => {
        return Number(a.srNo) - Number(b.srNo);
      })
    : [];

  const renderTableView = () => (
    <div className="table-responsive">
      <table className="documents-table">
        <thead>
          <tr>
            <th className="td-th-casedet">Sr No</th>
            <th className="td-th-casedet">Scrutiny Date</th>
            <th className="td-th-casedet">Objection</th>
            <th className="td-th-casedet">Compliance Date</th>
            <th className="td-th-casedet">Receipt Date</th>
          </tr>
        </thead>
        <tbody>
          {sortedObjections.map((obj, index) => (
            <tr key={index}>
              <td className="td-th-casedet">{obj.srNo}</td>
              <td className="td-th-casedet">{obj.scrutinyDate || "-"}</td>
              <td style={{ maxWidth: "400px", minWidth: "200px" }} className="td-th-casedet">
                <div
                  style={{
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    lineHeight: "1.4",
                  }}
                  title={obj.objection}
                >
                  {obj.objection ? formatText(obj.objection) : "-"}
                </div>
              </td>
              <td className="td-th-casedet">{obj.complianceDate || "-"}</td>
              <td className="td-th-casedet">{obj.receiptDate || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderGridView = () => (
    <div className="orders-grid-layout">
      {sortedObjections.map((obj, index) => (
        <div key={index} className="modern-order-card">
          {/* 1. Header: Sr No and Scrutiny Date */}
          <div className="card-header-strip">
            <div className="order-badge">
              <IoDocumentTextOutline /> No. {obj.srNo}
            </div>
            <div className="order-date">
              {obj.scrutinyDate ? `Scrutiny: ${obj.scrutinyDate}` : ""}
            </div>
          </div>

          {/* 2. Body: Objection Text */}
          <div className="card-content-body">
            {/* FIXED: Removed inline styles that forced right alignment */}
            <div className="detail-row">
              <div className="detail-label">
                <IoAlertCircleOutline className="row-icon" /> Objection
              </div>
              <div 
                className="detail-value judge-text" 
                title={obj.objection}
              >
                {obj.objection || "None"}
              </div>
            </div>

            <div className="detail-row">
              <div className="detail-label">
                <FaCheckCircle className="row-icon" /> Compliance
              </div>
              <div className="detail-value">{obj.complianceDate || "-"}</div>
            </div>

            <div className="detail-row">
              <div className="detail-label">
                <FaCalendarDays className="row-icon" /> Receipt
              </div>
              <div className="detail-value">{obj.receiptDate || "-"}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="tab-content">
      <div className="summary header-actions-container">
        <div className="sum-amount">
          <p className="margin-zero exp-count">
            <strong>Total Objections - </strong>{" "}
            {objectionDetails ? objectionDetails.length : 0}
          </p>
        </div>

        <div className="actions-right">
          {objectionDetails && objectionDetails.length > 0 && (
            <div className="view-toggles">
              <button
                className={`toggle-btn ${viewMode === "grid" ? "active" : ""}`}
                onClick={() => setViewMode("grid")}
                title="Grid View"
              >
                <IoGrid />
              </button>
              <button
                className={`toggle-btn ${viewMode === "table" ? "active" : ""}`}
                onClick={() => setViewMode("table")}
                title="Table View"
              >
                <FaTableList />
              </button>
            </div>
          )}
        </div>
      </div>

      {objectionDetails && objectionDetails.length === 0 ? (
        <div className="no-data-container">
          <h3 className="no-data-title">No Objections Found</h3>
          <p className="no-data-message">
            No objection details are available for this case.
          </p>
        </div>
      ) : viewMode === "table" ? (
        renderTableView()
      ) : (
        renderGridView()
      )}
    </div>
  );
};